var samsung_BN59_01178F = {
    name: "BN59_01178F",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [67,0,4,144,2,195,1,145,2,48,6,24,18,42,17,145,2,0,0,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [67,0,4,143,2,197,1,142,2,48,6,15,18,46,17,145,2,0,0,42,253,95,191,234,170,136],
        },
        {
            function: "KEY_BALL",
            name: "KEY_BALL",
            icon: "KEY_BALL",
            command: [67,0,4,135,2,203,1,137,2,56,6,15,18,61,17,141,2,0,0,42,253,95,245,106,189,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [67,0,4,138,2,202,1,138,2,53,6,15,18,57,17,138,2,0,0,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [67,0,4,136,2,201,1,136,2,58,6,14,18,58,17,136,2,0,0,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [67,0,4,154,2,194,1,155,2,23,6,45,18,37,17,167,2,0,0,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [67,0,4,145,2,202,1,150,2,30,6,253,17,73,17,150,2,0,0,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,136,2,202,1,138,2,55,6,32,18,64,17,138,2,0,0,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [67,0,4,148,2,186,1,152,2,43,6,33,18,36,17,148,2,0,0,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [67,0,4,168,2,168,1,158,2,34,6,31,18,31,17,151,2,0,0,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [67,0,4,155,2,195,1,153,2,24,6,40,18,22,17,173,2,0,0,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [67,0,4,141,2,197,1,143,2,48,6,43,18,43,17,141,2,0,0,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [67,0,4,153,2,189,1,160,2,27,6,37,18,30,17,171,2,0,0,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_TXX/MIX",
            name: "KEY_TXX/MIX",
            icon: "KEY_TXX/MIX",
            command: [67,0,4,150,2,199,1,154,2,22,6,15,18,60,17,157,2,0,0,42,253,95,235,117,218,136],
        },
        {
            function: "KEY_PRE-CH",
            name: "KEY_PRE-CH",
            icon: "KEY_PRE-CH",
            command: [67,0,4,140,2,209,1,144,2,34,6,229,17,91,17,148,2,0,0,42,253,95,174,253,106,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,150,2,196,1,157,2,26,6,23,18,44,17,152,2,0,0,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [67,0,4,137,2,201,1,131,2,62,6,28,18,62,17,129,2,0,0,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [67,0,4,150,2,197,1,156,2,21,6,23,18,56,17,170,2,0,0,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [67,0,4,149,2,198,1,153,2,28,6,34,18,25,17,153,2,0,0,42,253,95,251,213,106,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [67,0,4,148,2,198,1,163,2,18,6,34,18,24,17,165,2,0,0,42,253,95,170,255,170,136],
        },
        {
            function: "KEY_CH LIST",
            name: "KEY_CH LIST",
            icon: "KEY_CH LIST",
            command: [67,0,4,151,2,200,1,153,2,22,6,53,18,24,17,159,2,0,0,42,253,95,173,175,110,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,135,2,214,1,143,2,33,6,222,17,102,17,139,2,0,0,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_APPS",
            name: "KEY_APPS",
            icon: "KEY_APPS",
            command: [67,0,4,132,2,217,1,136,2,38,6,230,17,93,17,143,2,0,0,42,253,95,186,174,190,136],
        },
        {
            function: "KEY_GUIDE",
            name: "KEY_GUIDE",
            icon: "KEY_GUIDE",
            command: [67,0,4,134,2,202,1,134,2,63,6,9,18,60,17,129,2,0,0,42,253,95,170,239,214,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [67,0,4,138,2,200,1,137,2,55,6,8,18,53,17,137,2,0,0,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [67,0,4,138,2,196,1,138,2,57,6,13,18,59,17,137,2,0,0,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [67,0,4,137,2,201,1,138,2,54,6,18,18,53,17,138,2,0,0,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [67,0,4,140,2,198,1,141,2,52,6,41,18,47,17,142,2,0,0,42,253,95,222,182,174,136],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [67,0,4,137,2,200,1,137,2,56,6,16,18,58,17,139,2,0,0,42,253,95,246,181,110,136],
        },
        {
            function: "KEY_TOOLS",
            name: "KEY_TOOLS",
            icon: "KEY_TOOLS",
            command: [67,0,4,136,2,198,1,134,2,63,6,10,18,67,17,133,2,0,0,42,253,95,173,222,214,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [67,0,4,147,2,193,1,145,2,45,6,20,18,46,17,146,2,0,0,42,253,95,170,191,234,136],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [67,0,4,140,2,196,1,142,2,51,6,14,18,58,17,143,2,0,0,42,253,95,245,181,118,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [67,0,4,138,2,197,1,138,2,57,6,11,18,62,17,138,2,0,0,42,253,95,181,189,218,136],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [67,0,4,155,2,179,1,153,2,43,6,31,18,30,17,148,2,0,0,42,253,95,235,90,238,136],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [67,0,4,153,2,183,1,156,2,44,6,25,18,28,17,148,2,0,0,42,253,95,237,235,106,136],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [67,0,4,152,2,180,1,158,2,43,6,33,18,35,17,149,2,0,0,42,253,95,182,251,106,136],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [67,0,4,154,2,181,1,155,2,43,6,56,18,31,17,149,2,0,0,42,253,95,214,247,106,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [67,0,4,159,2,180,1,150,2,43,6,66,18,39,17,149,2,0,0,42,253,95,175,250,170,136],
        },
        {
            function: "KEY_SEARCH",
            name: "KEY_SEARCH",
            icon: "KEY_SEARCH",
            command: [67,0,4,158,2,176,1,156,2,42,6,32,18,35,17,148,2,0,0,42,253,95,174,175,94,136],
        },
        {
            function: "KEY_P.SIZE",
            name: "KEY_P.SIZE",
            icon: "KEY_P.SIZE",
            command: [67,0,4,158,2,179,1,150,2,43,6,32,18,40,17,147,2,0,0,42,253,95,213,93,250,136],
        },
        {
            function: "KEY_E-MANUAL",
            name: "KEY_E-MANUAL",
            icon: "KEY_E-MANUAL",
            command: [67,0,4,154,2,185,1,149,2,42,6,31,18,40,17,147,2,0,0,42,253,95,170,175,250,136],
        },
        {
            function: "KEY_PIP",
            name: "KEY_PIP",
            icon: "KEY_PIP",
            command: [67,0,4,158,2,179,1,151,2,43,6,32,18,41,17,147,2,0,0,42,253,95,253,213,90,136],
        },
        {
            function: "KEY_AD/SUBT",
            name: "KEY_AD/SUBT",
            icon: "KEY_AD/SUBT",
            command: [67,0,4,149,2,183,1,155,2,44,6,65,18,33,17,146,2,0,0,42,253,95,183,123,90,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [67,0,4,153,2,179,1,156,2,43,6,32,18,29,17,148,2,0,0,42,253,95,183,187,86,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,153,2,177,1,162,2,44,6,30,18,31,17,147,2,0,0,42,253,95,219,182,214,136],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,157,2,176,1,158,2,43,6,61,18,1,17,149,2,0,0,42,253,95,247,106,214,136],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [67,0,4,155,2,180,1,158,2,44,6,31,18,5,17,147,2,0,0,42,253,95,187,186,214,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [67,0,4,153,2,183,1,149,2,43,6,52,18,34,17,148,2,0,0,42,253,95,171,223,86,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [67,0,4,153,2,181,1,153,2,43,6,27,18,35,17,148,2,0,0,42,253,95,215,183,86,136],
        },
    ]
}
export default samsung_BN59_01178F